import { render, staticRenderFns } from "./InvoicedExpensesDonut.vue?vue&type=template&id=48ed73dc"
import script from "./InvoicedExpensesDonut.vue?vue&type=script&lang=js"
export * from "./InvoicedExpensesDonut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports